import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  SessionState,
  LoadSession,
  selectSessionState
} from '@ipreo/muni-shared';

@Injectable({
  providedIn: 'root'
})
export class SessionFacade {
  readonly sessionState$: Observable<SessionState>;

  constructor(private store: Store<Record<string, unknown>>) {
    this.sessionState$ = store.pipe(
      select(selectSessionState),
      map((sessionState) => {
        if (sessionState.error) {
          throw new Error(sessionState.error);
        } else {
          return sessionState;
        }
      })
    );
  }

  loadSession() {
    this.store.dispatch(new LoadSession());
  }
}
